<!-- @ts-nocheck -->
<template>
  <q-input
    v-bind="$attrs"
    filled
    :stack-label="!dense"
    :label="getLabel()"
    :placeholder="placeholder"
    :after="after"
    :align="align"
    :rows="rows"
    type="number"
    ref="qinput"
    :disable="localdisable"
    :readonly="localdisable"
    :hint="hint"
    :error="error"
    :error-message="errorMessage"
    :dense="dense"
    v-model="localvalue"
    @blur="onblur"
    @focus="onfocus"
    @update:modelValue="onchange"
    style="padding-bottom: 0"
    :mask="mask"
    fill-mask="0"
  >
    <slot v-for="(_, name) in $slots" :name="name" />
    <template v-for="(_, name) in $slots"
              v-slot:[name]="slotData"
    ><slot :name="name"
           v-bind="slotData"
    /></template>
  </q-input>
</template>

<script setup lang="ts">
// @ts-nocheck
import { onMounted, ref, watch } from "vue";
import { QInput } from "quasar";

defineOptions({ name: "IstNumberInput" });

const props = withDefaults(
  defineProps<{
    validation?: any;
    modelValue?: any;
    disable?: boolean | string;
    readonly?: boolean | string;
    placeholder?: string;
    label?: string;
    type?: string;
    focus?: boolean;
    min?: string;
    dense?: boolean | string;
    max?: string;
    minLength?: string;
    maxLength?: string;
    patternErrorMsg?: string;
    pattern?: string;
    rows?: string;
    align?: string;
    hint?: string | undefined;
    after?: [];
    error?: boolean;
    errorMessage?: string;
    mask?: string;
  }>(),
  {
    modelValue: 0,
    disable: false,
    readonly: false,
    placeholder: "",
    label: "",
    type: "",
    focus: false,
    min: "",
    dense: false,
    max: "",
    minLength: "",
    maxLength: "",
    patternErrorMsg: "",
    pattern: "",
    rows: "",
    align: "",
    hint: undefined,
    after: () => [],
    error: false,
    errorMessage: "",
    mask: ""
  }
);

const emit = defineEmits<{
  (e: "blur"): void;
  (e: "focus"): void;
  (e: "change", value: any): void;
  (e: "update:modelValue", value: any): void;
}>();

const qinput = ref<QInput | null>(null);
const localvalue = ref<any>(0);
const localdisable = ref<boolean>(false);

const getLabel = (): string | undefined => {
  if (!props.label || props.label === "") {
    return undefined;
  }
  const s: string = props.label.charAt(0).toUpperCase() + props.label.substring(1).toLowerCase();
  return s ? s : undefined;
};

onMounted(() => {
  if (props.focus) {
    (qinput.value as any)?.focus?.();
  }
  localvalue.value = props.modelValue;
  localdisable.value =
    (typeof props.disable === "boolean" && props.disable) || props.disable == "true";
});

watch(
  () => props.modelValue,
  (value) => {
    localvalue.value = value as any;
  }
);
watch(
  () => props.disable,
  (value) => {
    localdisable.value = value as any;
  }
);

const onblur = () => {
  emit("blur");
};

const onfocus = () => {
  emit("focus");
};

const onchange = () => {
  emit("change", localvalue.value);
  emit("update:modelValue", localvalue.value);
  return localvalue.value;
};
</script>

<style></style>
